/**
 * Shared helpers for the reporting screens.
 */

/** Mask all but the last 4 digits of a phone number. */
export function maskPhone(value: string | undefined | null): string {
  if (!value) return '—';
  const s = String(value);
  if (s.length <= 4) return s;
  const visible = s.slice(-4);
  return `${'*'.repeat(s.length - 4)}${visible}`;
}

/** "1" → "DTMF", "2" → "Call Patch", else "—". */
export function templateLabel(template: string | undefined | null): string {
  if (template === '1') return 'DTMF';
  if (template === '2') return 'Call Patch';
  return '—';
}

/** "—" for nullish/empty strings, otherwise the value as-is. */
export function dashIfEmpty(value: string | number | undefined | null): string {
  if (value === null || value === undefined) return '—';
  const s = String(value).trim();
  return s.length === 0 ? '—' : s;
}
